import {
  getSavedCover,
  handleSendKlaviyoEvents,
  OptionalLayout,
  OptionElementType,
  Options,
  subscribeDataChange,
  unsubscribeDataChange,
} from '@adaptis/flow-components';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import './PetsyRetrieveQuotePopups.scss';
import { IPetsyRetrieveQuotePopups } from './PetsyRetrieveQuotePopups.types';

export default function PetsyRetrieveQuotePopup(
  props: IPetsyRetrieveQuotePopups
) {
  const [renderKey, setRenderKey] = React.useState(0);
  const emailValidationPattern = `[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,63}`;
  const quoteValidationPattern = `^P[0-9]{7,}$`;
  const [isInvalidEmail, setIsInvalidEmail] = React.useState<boolean>(true);
  const [isInvalidQuote, setIsInvalidQuote] = React.useState<boolean>(true);
  const [isTouchedEmail, setIsTouchedEmail] = React.useState<boolean>(false);
  const [isTouchedQuote, setIsTouchedQuote] = React.useState<boolean>(false);
  const [emailInitialValue, setEmailInitialValue] = useState('');
  const [quoteInitialValue, setQuoteInitialValue] = useState('');
  const [enableButton, setEnableButton] = React.useState<boolean>(true);
  const [enableResendEmail, setEnableResendEmail] = React.useState<boolean>(
    false
  );
  const [showStartContent, setShowStartContent] = React.useState<boolean>(true);
  const [countdown, setCountdown] = React.useState<number>(0);
  const [isPhone, setIsPhone] = React.useState<boolean>(false);
  const [
    selectedRetrieveQuoteMethod,
    setSelectedRetrieveQuoteMethod,
  ] = useState('enterQuoteNumber');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isFirstInit, setIsFirstInit] = React.useState<boolean>(true);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [saveCoverData, setSaveCoverData] = React.useState<any>(null);
  const countdownRef = React.useRef<NodeJS.Timeout>();
  const retrieveQuoteOptionList = [
    {
      dataValue: 'enterQuoteNumber',
      optionElements: [
        {
          elementType: OptionElementType.Text,
          text: 'Enter my quote number to continue',
        },
      ],
    },
    {
      dataValue: 'sendEmail',
      optionElements: [
        {
          elementType: OptionElementType.Text,
          text: 'Email me a link to retrieve my quote',
        },
      ],
    },
  ];

  const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobile = mobileRegex.test(userAgent);
    const isSmallScreen = window.innerWidth < 768;
    const hasTouchScreen =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;
    return isMobile && isSmallScreen && hasTouchScreen;
  };

  React.useEffect(() => {
    setIsPhone(isMobileDevice());
    // console.log("[PPP-173] props.quoteNumberField: ", props.quoteNumberField);
    setQuoteInitialValue(props.quoteNumberField ?? '');
    const handleResize = () => {
      setIsPhone(isMobileDevice());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // console.log("[PPP-173] selectedRetrieveQuoteMethod: ", props.quoteNumberField);
    setEmailInitialValue('');
    if (isFirstInit) {
      setIsFirstInit(false);
      setQuoteInitialValue(props.quoteNumberField ?? '');
      if (props.quoteNumberField) {
        setIsInvalidQuote(false);
        setIsTouchedQuote(true);
        setEnableButton(false);
      }
    } else {
      setQuoteInitialValue('');
    }
    setIsInvalidEmail(true);
    setIsInvalidQuote(true);
    setIsTouchedEmail(false);
    setIsTouchedQuote(false);
    setErrorMessage('');
  }, [selectedRetrieveQuoteMethod]);

  useEffect(() => {
    // Anything in here is fired on component mount.
    subscribeDataChange('SelectedRetrieveQuoteMethod', handleOptionChange);

    return () => {
      // Anything in here is fired on component unmount.
      unsubscribeDataChange('SelectedRetrieveQuoteMethod');
    };
  }, [selectedRetrieveQuoteMethod]);

  function handleOptionChange(dataPath: string, dataField: string, data: any) {
    if (dataField === 'selectedRetrieveQuoteMethod') {
      setSelectedRetrieveQuoteMethod(data);
    }
  }

  const startCountdown = () => {
    setCountdown(60);
    setEnableResendEmail(false);

    countdownRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          if (countdownRef.current) {
            clearInterval(countdownRef.current);
          }
          setEnableResendEmail(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const clearCountdown = () => {
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
    }
  };

  const handleOpenEmailApp = () => {
    if (isPhone) {
      window.location.href = 'mailto:';
    } else {
      window.open('mailto:', '_blank');
    }
  };

  function checkInputsIfValid(
    retrieveQuoteMethod: string,
    stringInput: string
  ) {
    // console.log("[PPP-173] retrieveQuoteMethod", retrieveQuoteMethod);
    // console.log("[PPP-173] stringInput", stringInput);
    if (retrieveQuoteMethod === 'sendEmail') {
      if (stringInput) {
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(stringInput)) {
          // console.log("[PPP-173] Vao day 1");
          setEnableButton(true);
          return;
        } else {
          // console.log("[PPP-173] Vao day 2");
          setEnableButton(false);
        }
      }
    } else {
      if (stringInput) {
        if (!/^P[0-9]{7,20}$/i.test(stringInput)) {
          // console.log("[PPP-173] Vao day 3");
          setEnableButton(true);
          return;
        } else {
          // console.log("[PPP-173] Vao day 4");
          setEnableButton(false);
        }
      }
    }
  }

  function modalClose() {
    clearCountdown();
    props.onClose();
  }

  const optionRef = React.useRef<any>();
  async function getQuoteInfo(quoteNo: string) {
    let quoteInfo = await getSavedCover(quoteNo);
    // console.log("[PPP-173] quoteInfo", quoteInfo);
    return quoteInfo;
  }
  async function handleSubmitStep1() {
    checkInputsIfValid(selectedRetrieveQuoteMethod, emailInitialValue);
    if (!enableButton) {
      try {
        setIsLoading(true);
        // Call API to get email information
        let sendEmail: string = emailInitialValue;
        if (selectedRetrieveQuoteMethod === 'enterQuoteNumber') {
          let quoteInfo = await getQuoteInfo(quoteInitialValue);
          // console.log("[PPP-173] quoteInfo", quoteInfo);
          if (quoteInfo) {
            setIsLoading(false);
            props.onClose(quoteInitialValue, quoteInfo);
            return;
            // sendEmail = quoteInfo.holderEmail;
            // setEmailInitialValue(sendEmail);
          } else {
            throw new Error(
              "Oops, that didn't work. Please check your quote number and try again."
            );
          }
        }
        // After successful API call, send Klaviyo event
        let sendStatus: any = await handleSendKlaviyoEvents(
          'Retrieve_Saved_Details_Quote',
          [
            {
              email: sendEmail,
            },
          ]
        );
        // console.log("[PPP-173] sendStatus", sendStatus);
        if (!sendStatus || !sendStatus.success) {
          throw new Error(
            "Oops, that didn't work. Please check your email and try again."
          );
        }

        setShowStartContent(false);
        startCountdown();
      } catch (error: any) {
        setErrorMessage(
          error.message ||
            'Failed to retrieve quote information. Please try again.'
        );
        if (selectedRetrieveQuoteMethod === 'sendEmail') {
          setIsInvalidEmail(true);
          setIsTouchedEmail(true);
        } else {
          setIsInvalidQuote(true);
          setIsTouchedQuote(true);
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      setRenderKey((renderKey) => renderKey + 1);
    }
  }

  function handleSubmitStep2() {
    if (countdown) return;
    handleSendKlaviyoEvents('Retrieve_Saved_Details_Quote', [
      {
        email: emailInitialValue,
      },
    ]);
    startCountdown();
  }

  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    setErrorMessage('');
    if (selectedRetrieveQuoteMethod === 'sendEmail') {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;
      const isValid = emailRegex.test(e.target.value);
      setIsInvalidEmail(!isValid);
      setIsTouchedEmail(true);
      if (e.target.value === '') setIsTouchedEmail(false);
      setEmailInitialValue(e.target.value);
    } else {
      e.target.value = e.target.value.toUpperCase();
      const quoteRegex = /^P[0-9]{7,}$/;
      const isValid = quoteRegex.test(e.target.value);
      setIsInvalidQuote(!isValid);
      setIsTouchedQuote(true);
      if (e.target.value === '') setIsTouchedQuote(false);
      setQuoteInitialValue(e.target.value);
    }
    checkInputsIfValid(selectedRetrieveQuoteMethod, e.target.value);
  }

  function handleInputOnBlur(e: React.FocusEvent<HTMLInputElement>) {
    e.preventDefault();
    if (selectedRetrieveQuoteMethod === 'sendEmail') {
      if (e.target.value === '') setIsTouchedEmail(false);
    } else {
      e.target.value = e.target.value.toUpperCase();
      if (e.target.value === '') setIsTouchedQuote(false);
    }
    checkInputsIfValid(selectedRetrieveQuoteMethod, e.target.value);
  }

  // console.log("[PPP-173] errorMessage: ", errorMessage);
  function handleShowStep1() {
    return (
      <>
        <div className='ref-row'>
          <div className='welcome-back-content'>
            <h1>Welcome Back!</h1>
            <div className='ref-image'>
              <img src='/images/clap-icon.png' />
            </div>
          </div>
        </div>

        <div className='ref-row mt-3'>
          <div className='d-flex justify-content-left'>
            <label className='form-label purple-text h4'>
              How would you like to retrieve your quote?
            </label>
          </div>
          <div>
            <Options
              dataField='selectedRetrieveQuoteMethod'
              layout={OptionalLayout.RadioStacked}
              optionList={retrieveQuoteOptionList}
              stepSlug={''}
            />
          </div>
          <div className={'form-default mt-3'}>
            <label className='form-label' htmlFor='textEmailAddress'>
              {selectedRetrieveQuoteMethod === 'sendEmail'
                ? 'Email address'
                : 'Quote Number'}
            </label>
            {selectedRetrieveQuoteMethod === 'sendEmail' && (
              <input
                name='textEmailAddress'
                placeholder={`Enter the email you used to get your quote`}
                aria-describedby='textHelpBlock'
                id='textEmailAddress'
                value={emailInitialValue}
                readOnly={false}
                className={
                  'form-control ' +
                  (errorMessage ? 'is-error ' : '') +
                  (isTouchedEmail
                    ? isInvalidEmail
                      ? ' is-invalid'
                      : ' is-valid'
                    : '')
                }
                type={'email'}
                pattern={emailValidationPattern}
                onChange={handleInputChange}
                onBlur={handleInputOnBlur}
              />
            )}

            {selectedRetrieveQuoteMethod === 'enterQuoteNumber' && (
              <input
                name='textQuoteNumber'
                placeholder={`Enter your quote number`}
                aria-describedby='textHelpBlock'
                id='textQuoteNumber'
                value={quoteInitialValue}
                readOnly={false}
                className={
                  'form-control ' +
                  (errorMessage ? 'is-error' : '') +
                  (isTouchedQuote
                    ? isInvalidQuote
                      ? ' is-invalid'
                      : ' is-valid'
                    : '')
                }
                type={'text'}
                pattern={quoteValidationPattern}
                onChange={handleInputChange}
                onBlur={handleInputOnBlur}
              />
            )}
            <div className='invalid-feedback'>{errorMessage}</div>
          </div>
        </div>
        <div className='ref-row mt-4'>
          <Button
            key={renderKey}
            disabled={enableButton || isLoading}
            className={'flc_next-button btn'}
            onClick={handleSubmitStep1}
          >
            {isLoading ? (
              <>
                <span
                  className='spinner-border spinner-border-sm me-2'
                  role='status'
                  aria-hidden='true'
                ></span>
                Retrieving...
              </>
            ) : (
              'Retrieve My Quote'
            )}
          </Button>
        </div>
        <div className='ref-row mt-4 mb-2'>
          <hr />
        </div>
        <div className='ref-row mt-3'>
          <label className='or'>OR</label>
        </div>
        <div className='ref-row mt-3'>
          <Button
            key={`btn-step-back-${renderKey}`}
            className={'btn btn-link'}
            onClick={modalClose}
          >
            No thanks, I'll start from scratch
          </Button>
        </div>
        <div className='ref-row mt-3'>
          <label className='help'>
            Need help? Call us on <span>1300 952 790</span>
          </label>
        </div>
      </>
    );
  }

  function handleShowStep2() {
    return (
      <>
        <div className='ref-row'>
          <div className='ref-image'>
            <img src='/images/pet-with-toy.png' />
          </div>
          <p className='mt-4'>
            <label className='purple-text h4'>We've sent your quote</label>
          </p>

          <p>
            If we found a match, you'll get an email with a link to retrieve it.
          </p>

          <p>
            Look for the email subject: <br />
            <strong>"Retrieve Your Previous Petsy Quote"</strong>
          </p>
        </div>
        {/* Remove this section for 9.4.2025 */}
        {/* <div className="ref-row mt-4">
          {isPhone && <Button
            key={renderKey}
            className={"flc_next-button btn"}
            onClick={handleOpenEmailApp}
          >
            Open My Email App
          </Button>}
          {!isPhone && <Button
            key={renderKey}
            className={"flc_next-button btn"}
            onClick={modalClose}
          >
            Return to New Quote
          </Button>}
        </div>
        <div className="ref-row mt-4 mb-2">
          <hr />
        </div>
        <div className="ref-row mt-3">
          <label className="or">
            OR
          </label>
        </div> */}
        <div className='ref-row mt-3'>
          Didn't receive the email? <br />
          We sent it to{' '}
          <strong className='purple-text'>{emailInitialValue}</strong>
          <br />
          Double check for typos or{' '}
          <span
            onClick={handleSubmitStep2}
            className={`btn-link purple-text ${
              countdown > 0 ? 'disabled' : ''
            }`}
          >
            click here
          </span>{' '}
          to resend it. {countdown > 0 && `(${countdown}s)`}
          {/* <Button
            key={`btn-step-back-${renderKey}`}
            disabled={!enableResendEmail}
            className={"btn btn-link"}
            onClick={submit}
          >
            Didn't receive the email? Click here to resend. {countdown > 0 && `(${countdown}s)`}
          </Button> */}
        </div>
        <div className='ref-row mt-3'>
          <p>
            Emails may take a few minutes.
            <br />
            Check spam or junk folders.
          </p>
        </div>
      </>
    );
  }
  return (
    <>
      <Modal
        className='flc_petsy-retrieve-quote-popup'
        show={props.show}
        onHide={modalClose}
        backdrop='static'
        keyboard={false}
        fullscreen='sm-down'
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className='text-center' ref={optionRef}>
          {showStartContent ? handleShowStep1() : handleShowStep2()}
        </Modal.Body>
      </Modal>
    </>
  );
}
